import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { AsyncPaginate } from "react-select-async-paginate";

import { ActionTableSubmit } from "./ActionTableSubmit";

import Loading from "../../components/LoadingTable";
import { S3Uploader } from "../components/S3Uploader";

import { dataset } from "../../../apis";

import auth from "../../../Auth";

import toast from "react-hot-toast";

// import { TableProvider } from "./TableContext";

// modified to work for dataset submission

// figure how to generalize this component for both dataset and file submission

// TODO
// split into TableSubmitMerged and TableSubmit
export class TableSubmitMerged extends React.Component {
  constructor(props) {
    super(props);
    this.refsCollection = {};
    this.refsCollection2 = {};
  }

  getJSXerror = (row) =>
    row.error !== "" ? (
      <i id={`error_form_${row.id}-${row.index}`}>
        <font color="red"> {row.error} </font>
      </i>
    ) : null;

  getJSXSelectOptions = (header, row) =>
    header.selection.map((optionItem) =>
      optionItem === row.value ? (
        <option value={optionItem} selected>
          {optionItem}
        </option>
      ) : (
        <option value={optionItem}>{optionItem}</option>
      )
    );

  getJSXMultipleOptions = (header) =>
    header.selection.map((optionItem) => {
      return <option value={optionItem}> {optionItem} </option>;
    });

  /*Get Headers according to View Fields Configurations*/
  getHeaders = (headers, copyReason) => {
    //1. Headers [ { id:"ID", title : "myTitle", inputType:"text | select | selectMultiple | number" , description:"", mandatory:true, selection:[...]} ]
    const columns = [];
    for (let header of headers) {
      const headerTable = { accessor: header.id };
      const checkboxItem = "";

      headerTable.Header =
        "mandatory" in header || "description" in header
          ? (props) => (
              <div>
                {" "}
                {checkboxItem} {header.title}{" "}
                {header.mandatory ? <font color="red"> * </font> : null}
                {header.description !== "" ? (
                  <label title={header.description}>
                    {" "}
                    <i className="fa fa-comment-o" aria-hidden="true" />
                  </label>
                ) : null}{" "}
              </div>
            )
          : header.title;
      headerTable.style = { whiteSpace: "unset" };
      headerTable["minWidth"] = 260;
      columns.push(headerTable);
    }
    return columns;
  };

  getInputCellContents = (fieldHeader, fieldObject, onChange) => {
    //Return JSX Object according to the input type
    switch (fieldHeader.inputType) {
      // Same as in TableSubmit.js
      case "text":
        return (
          <div>
            {" "}
            <input
              type="text"
              name={`${fieldObject.id}-${fieldObject.index}`}
              value={fieldObject.value}
              onChange={onChange}
              style={{ minWidth: "240px" }}
            />
            {this.getJSXerror(fieldObject)}{" "}
          </div>
        );
      // Same as in TableSubmit.js
      case "select":
        return (
          <div>
            {" "}
            <select
              name={`${fieldObject.id}-${fieldObject.index}`}
              value={fieldObject.value}
              onChange={onChange}
              style={{ width: "240px" }}
            >
              {this.getJSXSelectOptions(fieldHeader, fieldObject)}{" "}
            </select>{" "}
            {this.getJSXerror(fieldObject)}{" "}
          </div>
        );
      case "select-dataset":
        return (
          <div>
            <AsyncPaginate
              name={`${fieldObject.id}-${fieldObject.index}`}
              value={fieldObject.valueIndex}
              loadOptions={this.props.loadDatasets}
              onChange={this.props.changeSelectExperiment}
              additional={{ page: 1 }}
              menuPortalTarget={document.body}
            />
            {this.getJSXerror(fieldObject)}
          </div>
        );
      case "file":
        const info = `${fieldObject.id}-${fieldObject.index}`;
        return (
          <div>
            {" "}
            <S3Uploader
              // enable the individual trigger of the function startUpload() in <ReactS3UploaderCustomFunctional>
              ref={(instance) => {
                this.refsCollection[info] = instance;
              }}
              rowId={fieldObject.index}
              onChange={this.props.changeHandlerFiles}
              handleUploadedFilesChanged={this.props.handleUploadedFilesChanged}
            />
            {this.getJSXerror(fieldObject)}{" "}
          </div>
        );
      // if there are more then one file upload fields
      // a new case is needed to handle the files
      case "file2":
        const info2 = `${fieldObject.id}-${fieldObject.index}`;
        // 
        return (
          <div>
            {" "}
            <S3Uploader
              // enable the individual trigger of the function startUpload() in <ReactS3UploaderCustomFunctional>
              id="file-uploader-2"
              ref={(instance) => {
                this.refsCollection2[info2] = instance;
              }}
              rowId={fieldObject.index}
              onChange={this.props.changeHandlerFiles2}
              handleUploadedFilesChanged={this.props.handleUploadedFilesChanged}
            />
            {this.getJSXerror(fieldObject)}{" "}
          </div>
        );
    }
  };

  getData = (headers, data, onChange) => {
    //1.Headers [ { id:"ID", title : "myTitle", inputType:"text | select | selectMultiple | number" , description:"", mandatory:true, selection:[...]} ]
    //2.Data  [{id:"ID", value:'VALUE'},...,{id:"ID", value:'VALUE'}] ,..., [{id:"ID", value:'VALUE'},...,{id:"ID", value:'VALUE'}]
    const dataTable = [];
    for (const row of data) {
      const dataRow = {};
      for (const field of row) {
        const fieldHeader = headers.find((header) => header.id === field.id);
        dataRow[field.id] = this.getInputCellContents(
          fieldHeader,
          field,
          onChange
        );
      }
      dataTable.push(dataRow);
    }
    return dataTable;
  };

  postDatasetData = async (filteredRows) => {
    const errors = [];
    const response = [];
    for (const row of filteredRows) {
      const metaData = {};
      for (const field of row) {
        metaData[field.id] = field.value;
      }

      // ! FIXME
      // figure out why in the first row the File is a string
      // and in the second row it is an array

      if (metaData.File instanceof Array) {
        metaData.File = metaData.File.join(",");
      }

      metaData.project_id = this.props.projectId;

      const resFileUploadStart = await dataset(
        auth.getToken(),
        config.api_endpoint,
        "create",
        JSON.stringify(metaData)
      );

      const data = await resFileUploadStart.json();
      response.push(data);
      if (resFileUploadStart.status != 200) {
        // TODO
        // the error message should be more specific
        // = hast to include the dataset id
        //* has to be changed on the server side
        toast.error(data.message);
        errors.push(data.message);
      }
    }

    return [response, errors];
  };

  render() {
    const columns = this.getHeaders(this.props.headers);
    const data = this.getData(
      this.props.headers,
      this.props.contents,
      this.props.changeHandler //in Submission.js
    );

    return (
      <div>
        <ActionTableSubmit
          submit={async () => {
            // return error if form is not valid
            const formControls = await this.props.validate();
            if (this.props.hasErrors(formControls)) {
              return;
            }

            //callback to parent to set the loading state
            this.props.setLoadingState(true);

            
            // 
            

            const filledRows = this.props.contents
              .flat()
              .filter((row) => row.id === "id") // dataset id
              .filter((row) => row.value !== "")
              .map((row) => row.index);

            // filter this.props.contents to get only the filled rows
            const filteredRows = this.props.contents.filter((d, i) =>
              filledRows.includes(i)
            );

            

            const [data, errors] = await this.postDatasetData(filteredRows);
            if (errors.length > 0) {
              return;
            }

            // rows with DataPolicyFiles
            const rowsWithDataPolicyFiles = this.props.contents
              .flat()
              .filter((row) => row.id === "file")
              .filter((row) => row.value.length !== 0);

            
            
            const rowsWithClinicalDataFiles = this.props.contents
              .flat()
              .filter((row) => row.id === "file2")
              .filter((row) => row.value.length !== 0);
            
            if (
              rowsWithDataPolicyFiles.length == 0 &&
              rowsWithClinicalDataFiles.length == 0
            ) {
              this.props.handleUploadedFilesChanged();
            }

            // callback to parent to set files selected state
            const allDataPolicyFiles = rowsWithDataPolicyFiles
              .map(({ value }) => value)
              .flat();

            

            const allClinicalDataFiles = rowsWithClinicalDataFiles
              .map(({ value }) => value)
              .flat();

            const allFiles = [...allDataPolicyFiles, ...allClinicalDataFiles];
            
            this.props.setSelectedFiles(allFiles);

            // filter refsCollection to only contain the refs in which the row is not empty
            // row index = <columnName>-<rowNumber>
            const filledRowsIdsDataPolicy = rowsWithDataPolicyFiles.map(
              ({ index }) => `file-${index}`
            );
            const filledRowsIdsClinicalData = rowsWithClinicalDataFiles.map(
              ({ index }) => `file2-${index}`
            );

            const neededRefs1 = Object.keys(this.refsCollection)
              .filter((key) => filledRowsIdsDataPolicy.includes(key))
              .reduce((obj, key) => {
                obj[key] = this.refsCollection[key];
                return obj;
              }, {});

            

            const neededRefs2 = Object.keys(this.refsCollection2)
              .filter((key) => filledRowsIdsClinicalData.includes(key))
              .reduce((obj, key) => {
                obj[key] = this.refsCollection2[key];
                return obj;
              }, {});

            for (const ref in neededRefs1) {
              
              await neededRefs1[ref].startUpload(
                this.props.contents, //contains all rows
                "dataPolicy",
                data
              );
            }

            for (const ref in neededRefs2) {
              
              await neededRefs2[ref].startUpload(
                this.props.contents, //contains all rows
                "clinicalData",
                data
              );
            }
            // const rowsWithFiles = this.props.contents
            //   .flat()
            //   .filter((row) => row.id === "file")
            //   .filter((row) => row.value.length !== 0);

            // if (rowsWithFiles.length == 0) {
            //   this.props.handleUploadedFilesChanged();
            // }

            // // callback to parent to set files selected state
            // const allFiles = rowsWithFiles.map(({ value }) => value).flat();
            // this.props.setSelectedFiles(allFiles);

            // // filter refsCollection to only contain the refs in which the row is not empty
            // const filledRowsIds = rowsWithFiles.map(
            //   ({ index }) => `file-${index}`
            // );

            // const neededRefs = Object.keys(this.refsCollection)
            //   .filter((key) => filledRowsIds.includes(key))
            //   .reduce((obj, key) => {
            //     obj[key] = this.refsCollection[key];
            //     return obj;
            //   }, {});

            // // this props.contents includes all the rows

            // // TODO
            // // this.props.contents contains all the rows
            // // maybe better to get only the rows with File(s)

            // // does not need the projectId to be passed

            // for (const ref in neededRefs) {
            //   await neededRefs[ref].startUpload(
            //     this.props.contents, //contains all rows
            //     this.props.projectId,
            //     data
            //   );
            // }
          }}
          addRow={this.props.addRow}
          validate={this.props.validate}
          reload={this.props.reload}
          loadFile={this.props.loadFile}
          getExcel={() => this.props.getExcel("file")}
        />
        <ReactTable
          data={data}
          columns={columns}
          minRows={0}
          pageSizeOptions={[50, 100, 200, 500]}
          defaultPageSize={100}
          sortable={false}
          loading={this.props.loading}
          LoadingComponent={Loading}
          className="-striped -highlight"
          style={{
            height: 700,
          }}
        />
      </div>
      // </TableProvider>
    );
  }
}
